import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button } from 'react-bootstrap';
import { IoEye } from 'react-icons/io5';
import { ModalUbahLead } from '../../../Modal';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeDark,
    colorSchemeLightCold,
    DateFilterModule,
    themeQuartz
} from 'ag-grid-community';
import { ThemeContext } from '../../../../auth';
import { useMediaQuery } from 'react-responsive';

function TableSalesPageAdminDark(
    {
        listLead,
        accessToken
    }
) {

    const isMobile = useMediaQuery({ maxWidth: 736 });

    const { theme } = useContext(ThemeContext);

    const [rowSelected, setRowSelected] = useState();
    const [showEditLead, setShowEditLead] = useState(false);
    const handleShowEditLead = (row) => {
        setShowEditLead(true);
        setRowSelected(row);
    };


    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = listLead?.map(({ ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {
                return {
                    ...data,
                    customerName: data?.customer?.title?.titleName + ". " + data?.customer.name,
                    salesName: data?.firstName + ' ' + data?.lastName,
                    status_lead: data?.status + '%'
                };
            })
        );
    }, [listLead]);

    ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);
    const themecolorSchemeDark = themeQuartz.withPart(colorSchemeDark);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (dataTable && dataTable.length > 0) {
            setRowData(dataTable);
        }
    }, [dataTable]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const dateParts = cellValue.split("-");
            const cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
            );

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };

    const colDefs = [
        {
            field: "noLead",
            headerName: "No. Lead",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.noLead}
                    </div>
                );
            },
        },
        {
            field: "date",
            headerName: "Tanggal",
            filter: "agDateColumnFilter",
            sort: 'desc',
            filterParams: filterParams,
        },
        {
            field: "customerName",
            headerName: "Customer",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.customerName}
                    </div>
                );
            },
        },
        {
            field: "status_lead",
            headerName: "Progress Lead",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.status_lead}
                    </div>
                );
            },
        },
        {
            field: 'detail',
            headerName: 'Detail',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowEditLead(row.data)}
                    >
                        <Button
                            variant='btn'
                            onClick={() => handleShowEditLead(row.data)}
                        >
                            &nbsp;<IoEye size={20} color={theme == 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;

                        </Button>
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 200); // Adjust as needed
        };

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div style={{ height: tableHeight }}>
            <AgGridReact
                theme={theme === "light" ? themecolorSchemeDark : themeLightCold}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                pagination={isMobile ? false : true}
                rowHeight={30}
            />
            <ModalUbahLead
                rowSelected={rowSelected}
                showEditLead={showEditLead}
                setShowEditLead={setShowEditLead}
                retrieveLead={null}
                accessToken={accessToken}
                listCustomer={null}
                retrieveCustomer={null}
            />
        </div>
    )
}

export default TableSalesPageAdminDark
